var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        staticClass: "practitioner-intern__page-header",
        attrs: { actions: _vm.headerActionConfig, page: _vm.pageHeaderConfig }
      }),
      _c("filter-manager", {
        ref: "filterComponent",
        staticClass: "mb-4 practitioner-intern__filter-manager",
        attrs: { filters: _vm.filtersConfig },
        on: {
          search: function($event) {
            return _vm.search(1)
          }
        },
        model: {
          value: _vm.selectedFilters,
          callback: function($$v) {
            _vm.selectedFilters = $$v
          },
          expression: "selectedFilters"
        }
      }),
      _c("separator", {
        staticClass: "pt-3 my-4",
        attrs: { text: "Resultado de Practicantes e Internos" }
      }),
      _vm.pagination.totalItemCount === 0 ? _c("result-not-found") : _vm._e(),
      _vm._l(_vm.pagination.data, function(result) {
        return _c("row", {
          key: result.id,
          staticClass: "mb-3",
          attrs: {
            "selected-academic-year": _vm.selectedFilters.academicYear.id,
            value: result
          }
        })
      }),
      _vm.pagination.totalItemCount > _vm.paginationPageMaxSize
        ? _c("pagination", {
            attrs: { data: _vm.pagination },
            on: { "pagination-go-page": _vm.setCurrentPage }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }